export default function BlockyBlasterIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#6CC4FF" />
      <path d="M2 40h60v8a14 14 0 0 1-14 14H16A14 14 0 0 1 2 48z" fill="#C9D1E6" />
      <rect x="6" y="18" width="14" height="24" fill="#4888FF" stroke="#1B1F2A" strokeWidth="2" />
      <rect x="46" y="22" width="12" height="20" fill="#FF6468" stroke="#1B1F2A" strokeWidth="2" />
      <rect x="24" y="22" width="16" height="12" rx="3" fill="#FFD23F" stroke="#1B1F2A" strokeWidth="2.5" />
      <rect x="27" y="25" width="10" height="5" rx="2" fill="#1B1F2A" />
      <rect x="30" y="26" width="5" height="3" rx="1" fill="#7CF4FF" />
      <rect x="22" y="34" width="20" height="12" rx="3" fill="#FFD23F" stroke="#1B1F2A" strokeWidth="2.5" />
      <path d="M32 22v-5" stroke="#1B1F2A" strokeWidth="2" />
      <circle cx="32" cy="16" r="2.5" fill="#FF5D8F" />
      <path d="M32 50v8M28 54h8" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
